import { fontstyle1, fontstyle3 } from "../../utils/fonts";

const ProcessCard = (props) => {
  return (
    <div style={fontstyle1}>
      <p className="text-3xl" style={fontstyle3}>
        {props.id}
      </p>
      <p className="text-xl mt-4">{props.name}</p>
      <p className="text-gray-500 w-52 text-sm mt-2" style={fontstyle3}>
        {props.desc}{" "}
        <span
          style={{
            fontWeight: "bold"
          }}
        >
          <a href={props.link}>{props.bolddesc}</a>
        </span>
      </p>
    </div>
  );
};

export default ProcessCard;
